import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@core/states/app.state';
import * as AuthActions from '@core/states/auth/auth.actions';
import { ApiError } from '@corezilla/api';
import { ApiErrorResponse } from '@corezilla/api/core/interfaces/api-error-response';
import { DialogService } from '@group24ag/flowkit';

export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store<AppState>);
  const dialogService = inject(DialogService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 errors (unauthorized)
      if (error.status === 401) {
        dialogService.closeAll();
        // End the session on a 401: the logout$ effect performs a full-page
        // redirect through the ediconf/Keycloak end_session chain, which clears
        // the stale session and lands the user back on the frontend login page.
        store.dispatch(AuthActions.logout());
      }
      const apiErrorResponse = buildApiErrorResponse(error);
      return throwError(() => new ApiError(apiErrorResponse));
    })
  );
};

/**
 * Build ApiErrorResponse from HttpErrorResponse,
 * if backend returns error in expected format, use it, otherwise create a default one
 */
const buildApiErrorResponse = (error: HttpErrorResponse): ApiErrorResponse => {
  const body = error.error;
  return body &&
    typeof body === 'object' &&
    body?.message &&
    body?.statusCode &&
    body?.errorCode
    ? body
    : {
        message: error.message || 'Unknown error',
        statusCode: error.status,
        errorCode: 'UNKNOWN',
      };
};
